import { z } from "zod";

import { COGNITO_CUSTOMER_CASE_SUMMARY_GROUPS, COGNITO_INTERNAL_STAFF_GROUPS } from "@recobra/core";

import { LiableVehicleSchema, VehicleDetailsSchema } from "../case";
import { CaseType } from "../case-core";
import { TaskSchema } from "./records";

const internalStaff = COGNITO_INTERNAL_STAFF_GROUPS;

const TaskAssigneeSchema = z.object({
  userId: z.string().min(1).optional().meta({ visibleTo: internalStaff }),
  username: z.string().min(1).meta({ visibleTo: internalStaff }),
  email: z.email().optional().meta({ visibleTo: internalStaff }),
  name: z.string().min(1).optional().meta({ visibleTo: internalStaff }),
  picture: z.string().optional().meta({ visibleTo: internalStaff }),
  groups: z.array(z.string()).meta({ visibleTo: internalStaff }),
  clientIds: z.array(z.string()).meta({ visibleTo: internalStaff }),
  branchIds: z.array(z.string()).meta({ visibleTo: internalStaff }),
  canAccessCase: z.boolean().optional().meta({ visibleTo: internalStaff }),
});

export const ListTaskAssigneesResponseSchema = z.object({
  users: z.array(TaskAssigneeSchema).meta({ visibleTo: internalStaff }),
});

const TaskCaseSummarySchema = z
  .object({
    caseType: CaseType.meta({ visibleTo: COGNITO_CUSTOMER_CASE_SUMMARY_GROUPS }),
    clientName: z.string().nullish().meta({ visibleTo: COGNITO_CUSTOMER_CASE_SUMMARY_GROUPS }),
    branchName: z.string().nullish().meta({ visibleTo: COGNITO_CUSTOMER_CASE_SUMMARY_GROUPS }),
    externalCode: z.string().nullish().meta({ visibleTo: internalStaff }),
    vehicle: VehicleDetailsSchema.nullish().meta({
      visibleTo: COGNITO_CUSTOMER_CASE_SUMMARY_GROUPS,
    }),
    liableVehicles: z.array(LiableVehicleSchema).default([]).meta({
      visibleTo: COGNITO_CUSTOMER_CASE_SUMMARY_GROUPS,
    }),
    debtorName: z.string().nullish().meta({ visibleTo: internalStaff }),
  })
  .describe("Denormalized case fields for list rendering and search")
  .meta({ visibleTo: COGNITO_CUSTOMER_CASE_SUMMARY_GROUPS });
export type TaskCaseSummary = z.infer<typeof TaskCaseSummarySchema>;

const TaskWithCaseSummarySchema = TaskSchema.extend({
  caseSummary: TaskCaseSummarySchema.nullish().describe(
    "Present when contextType is case; omitted/null otherwise",
  ),
});
export type TaskWithCaseSummary = z.infer<typeof TaskWithCaseSummarySchema>;

export const ListTasksResponseSchema = z.object({
  items: z.array(TaskWithCaseSummarySchema).meta({ visibleTo: "*" }),
  nextToken: z
    .string()
    .optional()
    .describe("Opaque pagination cursor; pass as nextToken to fetch more")
    .meta({ visibleTo: "*" }),
});
export type ListTasksResponse = z.infer<typeof ListTasksResponseSchema>;
